/**
 * Copyright 2017 OpenStack Foundation
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 * http://www.apache.org/licenses/LICENSE-2.0
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * */

import { LOGOUT_USER } from "openstack-uicore-foundation/lib/security/actions";
import {
  RECEIVE_BADGE_SCAN_EXTRA_QUESTIONS,
  BADGE_SCAN_EXTRA_QUESTION_ORDER_UPDATED,
  BADGE_SCAN_EXTRA_QUESTION_DELETED
} from "../actions/sponsor-actions";

const DEFAULT_STATE = {
  extraQuestions: [],
  total: 0
};

const sponsorBadgeScansExtraQuestionsList = (state = DEFAULT_STATE, action) => {
  const { type, payload } = action;

  switch (type) {
    case LOGOUT_USER:
      return DEFAULT_STATE;
    case RECEIVE_BADGE_SCAN_EXTRA_QUESTIONS: {
      const extraQuestions = payload.response.extra_questions ?? [];
      return { extraQuestions, total: extraQuestions.length };
    }
    case BADGE_SCAN_EXTRA_QUESTION_ORDER_UPDATED: {
      const extraQuestions = Array.isArray(payload) ? payload : [];
      return { extraQuestions, total: extraQuestions.length };
    }
    case BADGE_SCAN_EXTRA_QUESTION_DELETED: {
      const { questionId } = payload;
      const extraQuestions = state.extraQuestions.filter(
        (q) => q.id !== questionId
      );
      return { extraQuestions, total: state.total - 1 };
    }
    default:
      return state;
  }
};

export default sponsorBadgeScansExtraQuestionsList;
